<template>
  <div class="spin">
    <div class="spin-title">
      {{this.title}}
    </div>
    <div class="spin-edit">
        <button type="button" class="btn border-left-0 border-dark ctrbutton btn-spin-left" @click="change(false)">-</button>
        <button type="button" class="btn border-left-0 border-dark valuebutton btn-spin" :disabled="isdisabled" @click="setValue()">{{value}}</button>
        <button type="button" class="btn border-left-0 border-dark ctrbutton btn-spin-right" @click="change(true)">+</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'spin-edit',
  data() {
    return {
    };
  },
  props: {
    title: String,
    type: String,
  },
  components: {},
  computed: {
    isdisabled(){
      if (this.type === 'Startvalue'){
        if (this.$store.state.gebot.act > 0){
          return true
        } else {
          return false
        }
      } else {
        if (this.value > this.$store.state.gebot.act){
          return false
        } else {
          return true
        }
      }
    },
    value(){
      if (this.type === 'Startvalue'){
        return this.$store.state.gebot.start
      } else {
        return this.$store.state.gebot.schatz
      }
    }
  },
  methods: {
    setValue() {
      if (this.type === 'Startvalue'){
      this.$emit('setvalue', this.$store.state.gebot.start);
      } else {
      this.$emit('setvalue', this.$store.state.gebot.schatz);
      }
    },
    change(dir) {
      if (this.type === 'Startvalue'){
        if (dir) {
          this.$store.commit('SET_NEWSTART', 100)
        } else {
          this.$store.commit('SET_NEWSTART', -100)
        }
      } else {
        if (dir) {
          this.$store.commit('SET_NEWSCHATZ', 100)
        } else {
          this.$store.commit('SET_NEWSCHATZ', -100)
        }
      }
    }
  }
  
}
</script>

<style scoped>
@import '../../scss/classes.scss';

.spin{
  width: 30%;
}

.spin-title{
  width: 100%;
  height: 20%;
  font-size: 30pt;
}
.spin-edit{
  width: 100%;
  height: 80%;
  padding: 5px;
}
.valuebutton{
  font-size: 50pt;
  width: 50%;
  height: 100%;
}

</style>
